import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JsonDateInterceptor implements HttpInterceptor {
  private readonly _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(
      map((val: HttpEvent<T>) => {
        if (val instanceof HttpResponse) {
          const body = val.body;
          this.convert(body);
        }
        return val;
      }),
    );
  }

  isIsoDateString(value: unknown): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      return this._isoDateFormat.test(value);
    }
    return false;
  }

  convert<T>(body: T): T {
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    // Process each property in the object
    for (const key of Object.keys(body as object)) {
      const value = (body as Record<string, unknown>)[key];

      if (this.isIsoDateString(value)) {
        (body as Record<string, unknown>)[key] = new Date(value as string);
      } else if (typeof value === 'object') {
        this.convert(value);
      }
    }

    return body;
  }
}
